import type { QualityScore } from '@brent/shared/types'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@brent/core-ui/ui'
import { cn } from '@/lib/utils'

interface QualityDropdownProps {
  value: QualityScore
  onChange: (value: QualityScore) => void
  disabled?: boolean
  className?: string
}

const qualityOptions: { value: QualityScore; label: string }[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'needs_review', label: 'Needs Review' },
  { value: 'verified', label: 'Verified' },
]

const qualityColors: Record<QualityScore, string> = {
  pending: 'text-muted-foreground',
  needs_review: 'text-[hsl(var(--conf-med))]',
  verified: 'text-[hsl(var(--conf-high))]',
}

export function QualityDropdown({ value, onChange, disabled, className }: QualityDropdownProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as QualityScore)} disabled={disabled}>
      <SelectTrigger className={cn('h-8 w-[140px]', className)}>
        <SelectValue>
          <span className={qualityColors[value]}>
            {qualityOptions.find((o) => o.value === value)?.label}
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {qualityOptions.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            <span className={qualityColors[opt.value]}>{opt.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
